// Generated by ReScript, PLEASE EDIT WITH CARE


async function getEncryptedCard(cardPayloadJson) {
  try {
    var mod = await import("./ClickToPayCardEncryptionHelpers");
    var encryptCard = mod.encryptMessage;
    return await encryptCard(cardPayloadJson);
  }
  catch (exn){
    return "";
  }
}

export {
  getEncryptedCard ,
}
/* No side effect */
